export default __webpack_public_path__ + "static/media/satellite.c8e1205c.jfif";